import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { mediaUrl } from "@/lib/api";

const JournalPage = () => {
  const [articles, setArticles] = useState([]);
  useEffect(() => { api.get("/journal").then((r) => setArticles(r.data)).catch(() => {}); window.scrollTo(0, 0); }, []);
  return (
    <div className="max-w-[1600px] mx-auto px-6 md:px-10 pt-16 md:pt-24">
      <p className="overline text-gold mb-4">Our World</p>
      <h1 className="font-serif text-6xl md:text-8xl leading-none mb-16">Stories from our world.</h1>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12">
        {articles.map((a) => (
          <Link key={a.id} to={`/journal/${a.slug}`} className="group">
            <div className="img-zoom aspect-[4/5] overflow-hidden mb-4"><img src={mediaUrl(a.cover_image)} alt={a.title} loading="lazy" className="w-full h-full object-cover" /></div>
            <p className="overline text-espresso/50 mb-2">{a.category}</p>
            <h2 className="font-serif text-2xl md:text-3xl leading-tight group-hover:text-gold transition-colors">{a.title}</h2>
            <p className="text-sm text-espresso/60 mt-2 leading-relaxed">{a.excerpt}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default JournalPage;
